import React, { forwardRef, type ComponentProps } from 'react';
import { cn } from '@mentimeter/ragnar-tailwind-config';
import { Separator } from '@radix-ui/react-dropdown-menu';
import { menuSeparatorDefaultClasses } from '../menuSeparatorDefaultClasses';

export type DropdownMenuSeparatorProps = ComponentProps<typeof Separator>;

export const DropdownMenuSeparator = forwardRef<
  HTMLDivElement,
  DropdownMenuSeparatorProps
>((props, forwardedRef) => {
  const { className, ...rest } = props;
  return (
    <Separator
      ref={forwardedRef}
      className={cn(menuSeparatorDefaultClasses, 'my-2', className)}
      {...rest}
    />
  );
});
